
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/pistkarta",
      function () {
        return require("private-next-pages/[region]/[resort]/pistkarta.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/pistkarta"])
      });
    }
  